<div class="camera-events-layout">
    <app-camera-event-fetch-action [camera]="camera" [parkingSpaceId]="parkingSpaceId"
        (fetchCompleted)="onFetchCompleted($event)">
    </app-camera-event-fetch-action>

    <app-camera-event-fetch-history [cameraId]="camera.id" [selectedFetchId]="selectedFetch()?.id"
        [refreshKey]="historyKey()" (fetchSelected)="onFetchSelected($event)">
    </app-camera-event-fetch-history>

    <app-camera-event-replay [cameraId]="camera.id" [fetch]="selectedFetch()">
    </app-camera-event-replay>

    <app-camera-event-list [fetchId]="selectedFetch()?.id" [cameraId]="camera.id">
    </app-camera-event-list>
</div>